module.exports = __webpack_public_path__ + "static/media/file.09aac42a.png";